
import { User, Post, Product, Order, Message, Notification, SubscriptionTier, Analytics, ShippingAddress } from '../context/AppContext';

const generateAvatar = (seed: string, color: string) => {
  return `data:image/svg+xml,${encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
      <defs>
        <linearGradient id="grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style="stop-color:${color};stop-opacity:1" />
          <stop offset="100%" style="stop-color:#27272b;stop-opacity:1" />
        </linearGradient>
      </defs>
      <rect width="100" height="100" fill="url(#grad)"/>
      <text x="50" y="62" font-size="42" text-anchor="middle" fill="white" font-family="Arial" font-weight="600">${seed.charAt(0).toUpperCase()}</text>
    </svg>
  `)}`;
};

const generateCover = (color: string) => {
  return `data:image/svg+xml,${encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 150">
      <defs>
        <linearGradient id="coverGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style="stop-color:${color};stop-opacity:0.9" />
          <stop offset="50%" style="stop-color:#018cf1;stop-opacity:0.7" />
          <stop offset="100%" style="stop-color:#27272b;stop-opacity:1" />
        </linearGradient>
      </defs>
      <rect width="400" height="150" fill="url(#coverGrad)"/>
      <circle cx="350" cy="30" r="80" fill="rgba(255,255,255,0.05)"/>
      <circle cx="50" cy="120" r="60" fill="rgba(255,255,255,0.05)"/>
    </svg>
  `)}`;
};

const generateProductImage = (color: string, index: number) => {
  const patterns = ['◆', '●', '■', '▲', '★'];
  return `data:image/svg+xml,${encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 500">
      <defs>
        <linearGradient id="prodGrad${index}" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style="stop-color:#f8f9fa;stop-opacity:1" />
          <stop offset="100%" style="stop-color:#e9ecef;stop-opacity:1" />
        </linearGradient>
      </defs>
      <rect width="400" height="500" fill="url(#prodGrad${index})"/>
      <rect x="50" y="50" width="300" height="400" rx="10" fill="${color}" opacity="0.9"/>
      <text x="200" y="270" font-size="80" text-anchor="middle" fill="white" font-family="Arial">${patterns[index % 5]}</text>
      <text x="200" y="340" font-size="24" text-anchor="middle" fill="rgba(255,255,255,0.8)" font-family="Arial">EXCLUSIVE</text>
    </svg>
  `)}`;
};

const generateMediaPlaceholder = (type: string, index: number) => {
  const colors = ['#00aff0', '#018cf1', '#00aff0', '#018cf1'];
  const color = colors[index % colors.length];
  return `data:image/svg+xml,${encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400">
      <defs>
        <linearGradient id="mediaGrad${index}" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style="stop-color:${color};stop-opacity:0.9" />
          <stop offset="100%" style="stop-color:#27272b;stop-opacity:1" />
        </linearGradient>
      </defs>
      <rect width="400" height="400" fill="url(#mediaGrad${index})"/>
      <circle cx="200" cy="200" r="60" fill="rgba(255,255,255,0.15)"/>
      <text x="200" y="215" font-size="48" text-anchor="middle" fill="rgba(255,255,255,0.9)" font-family="Arial">${type === 'video' ? '▶' : '📷'}</text>
    </svg>
  `)}`;
};

export const adminUser: User = {
  id: 'admin',
  username: 'onlyjalen',
  displayName: 'Jalen',
  email: 'jalen@onlyjalen.com',
  avatar: 'https://jalenward.com/images/logosmall.png',
  coverImage: 'https://jalenward.com/images/LOGO.png',
  bio: '✨ Exclusive premium content creator\n🔥 Premium content daily\n💎 VIP experiences & exclusive drops\n💕 Thank you for the support!',
  isAdmin: true,
  isSubscribed: true,
  subscriptionTier: null,
  subscriptionExpiry: null,
  subscribers: 24850,
  posts: 342,
  likes: 1250000,
  earnings: 187500,
  availableBalance: 45000,
  pendingBalance: 12500,
  location: 'Los Angeles, CA',
  website: 'onlyjalen.com',
  joinDate: new Date('2022-01-15'),
  online: true,
  paypalEmail: 'payments@onlyjalen.com',
  shippingAddresses: [],
  wishlist: [],
  notificationPrefs: { newPosts: true, messages: true, orderUpdates: true, newProducts: true, promotions: true }
};

const defaultAddress: ShippingAddress = {
  id: 'addr1',
  name: 'Home',
  street: '123 Main Street',
  city: 'New York',
  state: 'NY',
  zip: '10001',
  country: 'USA',
  isDefault: true
};

export const buyerUser: User = {
  id: 'buyer1',
  username: 'fan_user',
  displayName: 'Jamie Smith',
  email: 'jamie@email.com',
  avatar: generateAvatar('J', '#8a96a3'),
  coverImage: generateCover('#8a96a3'),
  bio: 'Biggest fan! 💕',
  isAdmin: false,
  isSubscribed: true,
  subscriptionTier: 'premium',
  subscriptionExpiry: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
  subscribers: 0,
  posts: 0,
  likes: 0,
  earnings: 0,
  availableBalance: 0,
  pendingBalance: 0,
  location: 'New York, NY',
  joinDate: new Date('2023-06-15'),
  online: true,
  shippingAddresses: [defaultAddress],
  wishlist: ['prod2', 'prod4'],
  notificationPrefs: { newPosts: true, messages: true, orderUpdates: true, newProducts: true, promotions: false }
};

export const mockPosts: Post[] = [
  {
    id: 'p1',
    content: 'New exclusive photoshoot just dropped! 📸✨ Swipe through to see the full set. Only for my premium subscribers 💕',
    mediaType: 'image',
    mediaUrl: '/images/portfolio-1/1.png',
    mediaUrls: ['/images/portfolio-1/1.png', '/images/portfolio-1/2.png', '/images/portfolio-1/3.png'],
    isLocked: false,
    likes: 4523,
    comments: 234,
    tips: 890,
    likedBy: ['buyer1'],
    savedBy: ['buyer1'],
    timestamp: new Date(Date.now() - 1000 * 60 * 30)
  },
  {
    id: 'p2',
    content: 'Behind the scenes from today\'s video shoot 🎬 Full video coming soon!',
    mediaType: 'image',
    mediaUrl: '/images/portfolio-1/4.png',
    isLocked: false,
    likes: 3891,
    comments: 156,
    tips: 650,
    likedBy: ['buyer1'],
    savedBy: [],
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 2)
  },
  {
    id: 'p3',
    content: '🔥 EXCLUSIVE CONTENT 🔥\nThis one is special... unlock to see the full set from my vacation shoot!',
    mediaType: 'image',
    mediaUrl: '/images/portfolio-1/5.png',
    isLocked: true,
    price: 9.99,
    likes: 2234,
    comments: 89,
    tips: 1234,
    likedBy: [],
    savedBy: [],
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 5)
  },
  {
    id: 'p4',
    content: 'Morning vibes ☀️ Starting the day right! Who else is up early?',
    mediaType: 'image',
    mediaUrl: '/images/portfolio-1/6.png',
    isLocked: false,
    likes: 5678,
    comments: 345,
    tips: 432,
    likedBy: ['buyer1'],
    savedBy: ['buyer1'],
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 8)
  },
  {
    id: 'p5',
    content: '💎 PREMIUM ONLY 💎\nFull 20-minute video from my latest shoot. This one took weeks to create!',
    mediaType: 'image',
    mediaUrl: '/images/portfolio-2/1.png',
    isLocked: true,
    price: 24.99,
    likes: 8976,
    comments: 567,
    tips: 2340,
    likedBy: [],
    savedBy: [],
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 24)
  },
  {
    id: 'p6',
    content: 'Thank you all for 25K subscribers! 🎉 You guys are amazing! Special surprise coming this weekend...',
    mediaType: 'text',
    isLocked: false,
    likes: 12500,
    comments: 890,
    tips: 4500,
    likedBy: ['buyer1'],
    savedBy: [],
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 48)
  }
];

export const mockStories: Post[] = [
  {
    id: 'story1',
    content: '',
    mediaType: 'image',
    mediaUrl: '/images/portfolio-2/2.png',
    isLocked: false,
    isStory: true,
    expiresAt: new Date(Date.now() + 1000 * 60 * 60 * 20),
    likes: 0,
    comments: 0,
    tips: 0,
    likedBy: [],
    savedBy: [],
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 4)
  },
  {
    id: 'story2',
    content: '',
    mediaType: 'image',
    mediaUrl: '/images/portfolio-2/3.png',
    isLocked: false,
    isStory: true,
    expiresAt: new Date(Date.now() + 1000 * 60 * 60 * 18),
    likes: 0,
    comments: 0,
    tips: 0,
    likedBy: [],
    savedBy: [],
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 6)
  }
];

export const mockProducts: Product[] = [
  {
    id: 'prod1',
    name: 'Signature Logo Hoodie',
    description: 'Premium quality hoodie with embroidered logo. Super soft fleece interior, perfect for lounging or going out. Limited edition design.',
    price: 89.99,
    salePrice: 69.99,
    images: [generateProductImage('#00aff0', 0), generateProductImage('#018cf1', 1)],
    category: 'Hoodies',
    sizes: [
      { size: 'XS', stock: 5 },
      { size: 'S', stock: 12 },
      { size: 'M', stock: 8 },
      { size: 'L', stock: 15 },
      { size: 'XL', stock: 10 }
    ],
    stock: 50,
    featured: true,
    createdAt: new Date('2024-01-15'),
    sold: 234,
    rating: 4.9,
    reviews: 89
  },
  {
    id: 'prod2',
    name: 'Exclusive Crop Top',
    description: 'Fitted crop top with unique design. Made from breathable cotton blend. Perfect for summer!',
    price: 49.99,
    images: [generateProductImage('#018cf1', 2), generateProductImage('#00aff0', 3)],
    category: 'Tops',
    sizes: [
      { size: 'XS', stock: 8 },
      { size: 'S', stock: 15 },
      { size: 'M', stock: 20 },
      { size: 'L', stock: 12 }
    ],
    stock: 55,
    featured: true,
    createdAt: new Date('2024-02-01'),
    sold: 156,
    rating: 4.8,
    reviews: 67
  },
  {
    id: 'prod3',
    name: 'Designer Joggers',
    description: 'Comfortable joggers with tapered fit. Features side pockets and adjustable waistband.',
    price: 79.99,
    salePrice: 59.99,
    images: [generateProductImage('#27272b', 4)],
    category: 'Bottoms',
    sizes: [
      { size: 'S', stock: 10 },
      { size: 'M', stock: 18 },
      { size: 'L', stock: 14 },
      { size: 'XL', stock: 8 }
    ],
    stock: 50,
    featured: false,
    createdAt: new Date('2024-02-15'),
    sold: 98,
    rating: 4.7,
    reviews: 45
  },
  {
    id: 'prod4',
    name: 'Limited Edition Tee',
    description: 'Exclusive graphic tee with custom artwork. Only 100 made - get yours before they\'re gone!',
    price: 44.99,
    images: [generateProductImage('#00aff0', 5), generateProductImage('#8a96a3', 6)],
    category: 'Tops',
    sizes: [
      { size: 'S', stock: 3 },
      { size: 'M', stock: 5 },
      { size: 'L', stock: 2 },
      { size: 'XL', stock: 0 }
    ],
    stock: 10,
    featured: true,
    createdAt: new Date('2024-03-01'),
    sold: 90,
    rating: 5.0,
    reviews: 34
  },
  {
    id: 'prod5',
    name: 'Cozy Sweatpants',
    description: 'Ultra-soft sweatpants perfect for relaxing at home. Features embroidered logo on thigh.',
    price: 64.99,
    images: [generateProductImage('#8a96a3', 7)],
    category: 'Bottoms',
    sizes: [
      { size: 'XS', stock: 6 },
      { size: 'S', stock: 12 },
      { size: 'M', stock: 15 },
      { size: 'L', stock: 10 },
      { size: 'XL', stock: 8 }
    ],
    stock: 51,
    featured: false,
    createdAt: new Date('2024-03-10'),
    sold: 145,
    rating: 4.6,
    reviews: 52
  },
  {
    id: 'prod6',
    name: 'Exclusive Cap',
    description: 'Adjustable cap with embroidered logo. One size fits all. Curved brim design.',
    price: 34.99,
    images: [generateProductImage('#00aff0', 8)],
    category: 'Accessories',
    sizes: [{ size: 'One Size', stock: 25 }],
    stock: 25,
    featured: false,
    createdAt: new Date('2024-03-15'),
    sold: 78,
    rating: 4.8,
    reviews: 29
  }
];

export const mockOrders: Order[] = [
  {
    id: 'ord1',
    userId: 'buyer1',
    items: [
      { productId: 'prod1', productName: 'Signature Logo Hoodie', productImage: generateProductImage('#00aff0', 0), size: 'M', quantity: 1, price: 69.99 },
      { productId: 'prod6', productName: 'Exclusive Cap', productImage: generateProductImage('#00aff0', 8), size: 'One Size', quantity: 1, price: 34.99 }
    ],
    subtotal: 104.98,
    shipping: 9.99,
    tax: 8.40,
    total: 123.37,
    status: 'shipped',
    shippingAddress: defaultAddress,
    trackingNumber: 'TRK123456789',
    paypalTransactionId: 'PP-123456',
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 5),
    updatedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 2)
  },
  {
    id: 'ord2',
    userId: 'buyer1',
    items: [
      { productId: 'prod2', productName: 'Exclusive Crop Top', productImage: generateProductImage('#018cf1', 2), size: 'S', quantity: 2, price: 49.99 }
    ],
    subtotal: 99.98,
    shipping: 9.99,
    tax: 8.00,
    total: 117.97,
    status: 'delivered',
    shippingAddress: defaultAddress,
    trackingNumber: 'TRK987654321',
    paypalTransactionId: 'PP-654321',
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 30),
    updatedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 25)
  }
];

export const mockMessages: Message[] = [
  {
    id: 'm1',
    fromUserId: 'admin',
    toUserId: 'buyer1',
    content: 'Hey! Thanks so much for subscribing! 💕 Let me know if you have any special requests!',
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 2),
    read: true
  },
  {
    id: 'm2',
    fromUserId: 'buyer1',
    toUserId: 'admin',
    content: 'Love your content! Can\'t wait for the new collection drop!',
    timestamp: new Date(Date.now() - 1000 * 60 * 60),
    read: true
  },
  {
    id: 'm3',
    fromUserId: 'admin',
    toUserId: 'buyer1',
    content: 'Aww thank you! 🥰 It\'s coming this weekend! You\'re going to love it!',
    timestamp: new Date(Date.now() - 1000 * 60 * 30),
    read: false
  }
];

export const mockNotifications: Notification[] = [
  {
    id: 'n1',
    type: 'post',
    title: 'New Post!',
    message: 'Jalen Ward just posted new content',
    timestamp: new Date(Date.now() - 1000 * 60 * 30),
    read: false
  },
  {
    id: 'n2',
    type: 'order',
    title: 'Order Shipped!',
    message: 'Your order #ord1 has been shipped',
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 24 * 2),
    read: true
  },
  {
    id: 'n3',
    type: 'product',
    title: 'New Drop Alert!',
    message: 'Limited Edition Tee is now available',
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 24 * 3),
    read: true
  },
  {
    id: 'n4',
    type: 'message',
    title: 'New Message',
    message: 'Jalen Ward sent you a message',
    timestamp: new Date(Date.now() - 1000 * 60 * 30),
    read: false
  }
];

export const subscriptionTiers: SubscriptionTier[] = [
  {
    id: 'monthly',
    name: '1 Month',
    price: 25,
    features: ['Unlimited access to exclusive photos & videos', 'Like & comment on all posts', 'Direct messaging access', 'New content daily']
  },
  {
    id: 'quarterly',
    name: '3 Months',
    price: 40,
    features: ['Everything in Monthly', 'Save $35 vs monthly', 'Priority support', 'Early access to new content'],
    isPopular: true
  },
  {
    id: 'yearly',
    name: '1 Year',
    price: 100,
    features: ['Everything in 3 Months', 'Save $200 vs monthly', 'Exclusive yearly member perks', 'VIP chat access']
  },
  {
    id: 'lifetime',
    name: 'Lifetime',
    price: 250,
    features: ['Everything forever', 'Best Value - Pay Once!', 'All future content included', 'Lifetime VIP status', 'Exclusive lifetime member badge']
  }
];

export const mockAnalytics: Analytics = {
  totalRevenue: 187500,
  subscriptionRevenue: 125000,
  productRevenue: 52500,
  tipRevenue: 10000,
  totalSubscribers: 24850,
  activeSubscribers: 18500,
  totalOrders: 1250,
  pendingOrders: 45,
  totalProducts: 6,
  lowStockProducts: 1,
  revenueByMonth: [
    { month: 'Jan', amount: 12500 },
    { month: 'Feb', amount: 15000 },
    { month: 'Mar', amount: 18000 },
    { month: 'Apr', amount: 16500 },
    { month: 'May', amount: 21000 },
    { month: 'Jun', amount: 19500 }
  ],
  subscribersByMonth: [
    { month: 'Jan', count: 15000 },
    { month: 'Feb', count: 17500 },
    { month: 'Mar', count: 19000 },
    { month: 'Apr', count: 21000 },
    { month: 'May', count: 23000 },
    { month: 'Jun', count: 24850 }
  ],
  topProducts: [
    { name: 'Signature Logo Hoodie', sales: 234 },
    { name: 'Exclusive Crop Top', sales: 156 },
    { name: 'Cozy Sweatpants', sales: 145 }
  ]
};
